/**
 * useMobileMenu - Custom hook for mobile menu management
 * Provides controlled menu open/close functionality with proper cleanup
 */

import { useCallback } from 'react';

export const useMobileMenu = () => {
  const openMenu = useCallback(() => {
    const sideNav = document.getElementById('sidenav');
    if (sideNav) {
      sideNav.style.width = '53%';
      // Add aria attributes for accessibility
      sideNav.setAttribute('aria-hidden', 'false');
      
      // Focus trap for accessibility
      const firstFocusable = sideNav.querySelector('button, [tabindex]:not([tabindex="-1"])');
      if (firstFocusable) {
        firstFocusable.focus();
      }
    }
  }, []);

  const closeMenu = useCallback(() => {
    const sideNav = document.getElementById('sidenav');
    if (sideNav) {
      sideNav.style.width = '0px';
      // Update aria attributes
      sideNav.setAttribute('aria-hidden', 'true');
    }
  }, []);

  return {
    openMenu,
    closeMenu,
  };
};
